import { Box, Stack, TableSortLabel, Typography } from '@mui/material';

import {
  IPaginationProps,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@occc-app/design-system';
import { SortingDirection } from '@occc-app/hooks/useSortingParams';
import { formatCompactNumber } from '@occc-app/lib/numbers';
import { RetailerNetworkLocationOfferMetricsOverviewFragment } from '@occc/graphql';
import { TrendBadgeDelta } from '@occc/ui-design-system';

type OfferPerformanceTableProps = {
  data?: RetailerNetworkLocationOfferMetricsOverviewFragment[];
  paginationProps: IPaginationProps;
  sortDirection: SortingDirection;
  isRetailerNetworkSiteUserRole: boolean;
  onSort: () => void;
};

export const OfferPerformanceTable = ({
  data,
  paginationProps,
  sortDirection,
  isRetailerNetworkSiteUserRole,
  onSort,
}: OfferPerformanceTableProps) => {
  if (!data || data.length === 0) {
    return (
      <Typography align='center'>
        {isRetailerNetworkSiteUserRole
          ? 'No active offers found for this store.'
          : 'No offer redemptions reported for this time range.'}
      </Typography>
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel active direction={sortDirection} onClick={onSort}>
                Top Performing Offers
              </TableSortLabel>
            </TableCell>
            <TableCell>Avg Redemption per Store per Day</TableCell>
            <TableCell align='right'>Redemptions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item: RetailerNetworkLocationOfferMetricsOverviewFragment) => (
            <TableRow key={item.uuid}>
              <TableCell>{item.offerName}</TableCell>
              <TableCell>{item.averageRedemptionsPerStore}</TableCell>
              <TableCell align='right'>
                <Stack alignItems='center' justifyContent='flex-end' spacing={1} direction='row'>
                  <TrendBadgeDelta
                    value={item.redemptions}
                    prevValue={item.prevPeriodRedemptions}
                  />
                  <Box sx={{ minWidth: 50 }}>{formatCompactNumber(item.redemptions)}</Box>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Pagination {...paginationProps} />
    </TableContainer>
  );
};
